import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {map, Observable} from 'rxjs';
import {UserSessionService} from '../services/user-session-service/user-session.service';
import {RedirectUrlService} from '../services/redirect-url-service/redirect-url.service';

@Injectable({providedIn: 'root'})
export class IsLoggedInGuard {
  private readonly userSessionService = inject(UserSessionService);
  private readonly router = inject(Router);
  private readonly redirectUrlService = inject(RedirectUrlService);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.userSessionService.waitForSession().pipe(
      map(user => {
        if (user != null) {
          return true;
        }
        this.redirectUrlService.setRedirectUrl(state.url);
        return this.router.createUrlTree(['/login']);
      })
    );
  }
}
